import React from 'react';

import './BlogPostCommentCard.css';

const BlogPostCommentCard = ({ comment }) => {
  const formattedDate = comment.commentedAt
    ? new Date(comment.commentedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : '';

  return (
    <div className='blog-post-comment-card-container'>
      <p className='blog-post-comment-card-name'>{comment.name}</p>
      <p className='blog-post-comment-card-commented-on'>{`Commented on ${formattedDate}`}</p>
      <p className='blog-post-comment-card-content'>{comment.content}</p>
    </div>
  );
};

export default BlogPostCommentCard;
